import { useMemo } from 'react';
import debounce from 'lodash.debounce';

// export default function useDebounce(cb: (value?: string) => void) {
//   return useMemo(() => debounce((value?: string) => cb(value), 500), [])
//   // return (value: string) => f(value)
// }
export default function useDebounce(cb: any) {
  return useMemo(() => debounce(cb, 500), [cb]);
  // return (value: string) => f(value)
}
